<template>
  <div class="device-auth-page">
    <div class="intro">
      <div>
        <strong>待处理登录请求</strong>
        <p>弹窗关闭或页面刷新后，可以回到这里允许、拒绝登录，或查看备用验证码。</p>
      </div>
      <el-button size="small" icon="el-icon-refresh" @click="load">刷新</el-button>
    </div>

    <el-alert v-if="!primaryDevice" title="当前设备不是主设备，只有主设备可以处理登录授权请求" type="warning" :closable="false" show-icon />
    <el-empty v-else-if="!requests.length" description="暂无待处理的登录授权" />
    <div v-else class="request-list">
      <div v-for="item in requests" :key="item.requestId" class="request-card">
        <div class="request-main">
          <div class="request-title">{{ item.terminalName }} 新设备</div>
          <div class="request-info">{{ item.deviceSummary || formatDeviceInfo(item.deviceInfo) }}</div>
          <div class="request-ip">登录 IP：{{ formatIp(item.loginIp) }}</div>
        </div>
        <div class="backup-code">
          <span>备用验证码</span>
          <strong>{{ item.authCode }}</strong>
          <el-button type="text" @click="copyCode(item.authCode)">复制</el-button>
        </div>
        <div class="actions">
          <el-button size="small" @click="decide(item, false)">拒绝</el-button>
          <el-button size="small" type="primary" @click="decide(item, true)">允许登录</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeviceAuthRequests',
  data() {
    return { primaryDevice: false, requests: [] };
  },
  methods: {
    init() { this.load(); },
    load() {
      return this.$http({ url: '/user/device/current/primary', method: 'get' }).then(primary => {
        this.primaryDevice = primary === true;
        if (!this.primaryDevice) {
          this.requests = [];
          return;
        }
        return this.$http({ url: '/user/device/auth/pending', method: 'get' }).then(data => {
          this.requests = data || [];
        });
      });
    },
    decide(item, approved) {
      this.$http({ url: '/user/device/auth/decision', method: 'post', data: { requestId: item.requestId, approved } })
        .then(() => {
          this.$message.success(approved ? '已允许该设备登录' : '已拒绝该设备登录');
          this.load();
        });
    },
    copyCode(code) {
      navigator.clipboard.writeText(code).then(() => this.$message.success('备用验证码已复制'))
        .catch(() => this.$message.warning('复制失败，请手动输入验证码'));
    },
    formatIp(ip) {
      return ip === '0:0:0:0:0:0:0:1' ? '本机（IPv6）' : (ip || '未知');
    },
    formatDeviceInfo(info) {
      if (!info) return '未知设备';
      try {
        const value = typeof info === 'string' ? JSON.parse(info) : info;
        return [value.platform, value.model, value.system, value.appVersion].filter(Boolean).join(' · ') || String(info);
      } catch (e) {
        return String(info).replace(/\s*\|\s*/g, ' · ');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.device-auth-page { padding: 28px; }
.intro { display:flex;align-items:center;justify-content:space-between;padding:18px 20px;margin-bottom:20px;border-radius:10px;background:#f2f5ff; }
.intro strong { font-size:16px; }
.intro p { margin:7px 0 0;color:#737789;font-size:13px; }
.request-list { display:flex;flex-direction:column;gap:14px; }
.request-card { display:flex;align-items:center;gap:24px;padding:20px;border:1px solid #e8eaf0;border-radius:10px;background:#fff; }
.request-main { flex:1;min-width:0; }
.request-title { font-size:16px;font-weight:600; }
.request-info,.request-ip { margin-top:7px;color:#85899a;font-size:13px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis; }
.backup-code { display:flex;flex-direction:column;align-items:center;min-width:120px;color:#8b8e9c;font-size:12px; }
.backup-code strong { margin-top:5px;color:var(--im-color-primary);font-size:22px;letter-spacing:3px; }
.actions { display:flex;white-space:nowrap; }
</style>
